import { MouseEvent, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Menu, MenuItem } from '@mui/material';
import DashboardCustomize from '@mui/icons-material/DashboardCustomize';
import { useNavigate } from 'react-router';
import { MobileMarketingNavBar } from './MobileMarketingNavBar.tsx';

export const ContactUsButton = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box className="contact-us-menu">
      <IconButton
        className="contact-us-icon-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        color="inherit"
        sx={{
          backgroundColor: '#164570',
          flexFlow: 'column',
          flex: 'none',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          paddingLeft: '58px',
          paddingRight: '58px',
          fontSize: '14px',
          lineHeight: '18px',
          textDecoration: 'none',
          display: 'flex',
          borderRadius: '0px',
        }}
      >
        (561)375-5834
      </IconButton>
      <IconButton
        className="hamburger-menu-icon-button"
        aria-haspopup="true"
        onClick={handleMenuToggle}
        color="inherit"
        sx={{
          display: 'none', // Default hidden
        }}
      >
        <DashboardCustomize />
      </IconButton>
      <Menu
        id="contact-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        <MenuItem>
          <Box onClick={() => void navigate('/contact')}>
            <Typography style={{ color: '#1D1B20' }} className="link">
              Schedule a meeting
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem>
          <Typography style={{ color: '#1D1B20' }} className="link">
            <a href="https://www.immersivehomes.com/contact" target="_blank">
              Contact Us
            </a>
          </Typography>
        </MenuItem>
      </Menu>
      <MobileMarketingNavBar
        menuOpen={menuOpen}
        handleMenuToggle={handleMenuToggle}
      />
    </Box>
  );
};

